import React, {ReactNode} from 'react';
import {Scrollbar} from '@priority-software/priority-style-react';
import cx from 'classnames';
import {useScrollWrapDimensions} from '../../../hooks/customScroll/useScrollWrapDimensions';
import {isRTL} from '../../../Localization';
import styles from './style.module.scss';
import {createDataTestId} from '../../../utils/dataTestId';

type Props = {
    children: ReactNode;
    fixedHeader?: ReactNode;
    defaultScrollMaxHeight?: number;
    componentClasses?: string;
    dataTestId?: string;
    thinPadding?: boolean;
};

const rtl = isRTL();

export const PanelBlock = ({
    defaultScrollMaxHeight,
    fixedHeader,
    children,
    componentClasses = null,
    dataTestId,
    thinPadding
}: Props) => {
    const {setWrapRef, maxHeight: scrollMaxHeight} = useScrollWrapDimensions();

    const additionalFixedHeader = fixedHeader ? {[styles.hasFixedHeader]: !!fixedHeader} : null;

    return (
        <div
            className={cx(styles.panel, additionalFixedHeader, componentClasses, {
                [styles.thinPadding]: thinPadding
            })}
            {...createDataTestId(dataTestId, false)}
        >
            {fixedHeader}
            <div className={styles.panelInner} ref={setWrapRef}>
                <Scrollbar
                    autoHeightMax={defaultScrollMaxHeight || scrollMaxHeight}
                    autoHeight
                    rtl={rtl}
                >
                    <div className={styles.scrollInner}>{children}</div>
                </Scrollbar>
            </div>
        </div>
    );
};
